export const WebChatLayout = {
  OVER_UNDER: "OVER_UNDER",
  SIDE_BY_SIDE: "SIDE_BY_SIDE",
  ONE_BOX: "ONE_BOX",
};






// WEBPACK FOOTER //
// ./src/types.js